import { Modal, Row, Col, message, Spin } from 'antd';
import Pagination from '@/components/pagination';
import { useEffect, useState } from 'react';
import taskApi from '@/api/task';
import format from '@/utils/format';
interface LogItem {
    taskerFullName: string;
    avatarUrl: string;
    status: string;
    createTime: string;
}
const TaskLogModal = ({ taskId, onCancel }: { taskId: string; onCancel: () => void }) => {
    const [taskLog, setTaskLog] = useState<{ total: number; list: LogItem[] }>({ total: 0, list: [] });
    const [pageNum, setPageNum] = useState(1);
    const [loadingLog, setLoading] = useState(false);
    const getTaskLog = async () => {
        setLoading(true);
        try {
            const res = await taskApi.tasklog(taskId, pageNum);
            const { total, records } = res.data;
            setTaskLog({ total: Number(total), list: records });
        } catch (error: any) {
            message.error(error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        taskId && getTaskLog();
    }, [taskId, pageNum]);
    const formatNum = (index: number) => {
        const currentIndex = (pageNum - 1) * 10 + index + 1;
        return taskLog.total - currentIndex + 1;
    };
    return (
        <Modal
            width={809}
            open={taskId ? true : false}
            onCancel={() => {
                setTaskLog({ total: 0, list: [] });
                onCancel();
            }}
            centered
            maskClosable={false}
            destroyOnClose
        >
            <div className="modal-title">Task Assignment Log</div>
            <div className="log-table">
                <div className="table-th">
                    <Row>
                        <Col span={8}>Task</Col>
                        <Col span={8}>Status</Col>
                        <Col span={8}>Received Time</Col>
                    </Row>
                </div>
                {loadingLog ? (
                    <div style={{ minHeight: 360 }} className="flex-center">
                        <Spin />
                    </div>
                ) : (
                    <div style={{ minHeight: 360 }}>
                        {taskLog.list.map((i, index) => {
                            return (
                                i.status && (
                                    <Row className="table-tr" key={index}>
                                        <Col span={8}>
                                            <span className="tasker-num">{formatNum(index)}</span>
                                            {i.status === 'Finding' ? (
                                                <span style={{ marginLeft: 16 }}>No next tasker</span>
                                            ) : (
                                                <>
                                                    <img
                                                        src={
                                                            i.avatarUrl || require('@/assets/images/default-avatar.png')
                                                        }
                                                        alt="tasker-avatar"
                                                    />
                                                    {i.taskerFullName || '-'}
                                                </>
                                            )}
                                        </Col>
                                        <Col
                                            span={8}
                                            style={{
                                                color:
                                                    i.status === 'Rejected' || i.status === 'Cancelled'
                                                        ? '#FF2626'
                                                        : i.status === 'Accepted'
                                                        ? '#7DB8A4'
                                                        : '#F76D20',
                                            }}
                                        >
                                            {i.status === 'Finding' || i.status === 'Waiting'
                                                ? `${i.status}...`
                                                : i.status}
                                        </Col>
                                        <Col span={8}>
                                            {i.status === 'Finding'
                                                ? '-'
                                                : format.customFormat(i.createTime, 'HH:mm A, D MMM YYYY')}
                                        </Col>
                                    </Row>
                                )
                            );
                        })}
                    </div>
                )}

                <Pagination total={taskLog.total} pageChange={setPageNum} pageNo={pageNum} />
            </div>
        </Modal>
    );
};
export default TaskLogModal;
